/**
 * Stock Logo Utilities
 * Maps ticker symbols to company logos using CDN with fallbacks
 */

// Domain mapping for logo CDN services
const TICKER_TO_DOMAIN: Record<string, string> = {
  // Tech Giants
  AAPL: 'apple.com',
  MSFT: 'microsoft.com',
  GOOGL: 'google.com',
  GOOG: 'google.com',
  AMZN: 'amazon.com',
  META: 'meta.com',
  NVDA: 'nvidia.com',
  TSLA: 'tesla.com',

  // Software & Cloud
  ADBE: 'adobe.com',
  CRM: 'salesforce.com',
  ORCL: 'oracle.com',
  NOW: 'servicenow.com',
  INTU: 'intuit.com',
  WDAY: 'workday.com',
  TEAM: 'atlassian.com',
  ZS: 'zscaler.com',
  OKTA: 'okta.com',
  PANW: 'paloaltonetworks.com',
  FTNT: 'fortinet.com',

  // Semiconductors
  INTC: 'intel.com',
  AMD: 'amd.com',
  AVGO: 'broadcom.com',
  QCOM: 'qualcomm.com',
  TXN: 'ti.com',
  MU: 'micron.com',
  AMAT: 'appliedmaterials.com',
  LRCX: 'lamresearch.com',
  KLAC: 'kla.com',
  ADI: 'analog.com',
  MRVL: 'marvell.com',
  ON: 'onsemi.com',
  NXPI: 'nxp.com',
  MCHP: 'microchip.com',
  ARM: 'arm.com',

  // Internet & Media
  NFLX: 'netflix.com',
  PYPL: 'paypal.com',
  SHOP: 'shopify.com',
  SQ: 'squareup.com',
  UBER: 'uber.com',
  LYFT: 'lyft.com',
  SNAP: 'snap.com',
  PINS: 'pinterest.com',
  SPOT: 'spotify.com',
  ZM: 'zoom.us',
  DOCU: 'docusign.com',
  ABNB: 'airbnb.com',
  DASH: 'doordash.com',
  RBLX: 'roblox.com',
  U: 'unity.com',
  ROKU: 'roku.com',
  TTWO: 'take2games.com',
  EA: 'ea.com',

  // Enterprise Software & Data
  PLTR: 'palantir.com',
  SNOW: 'snowflake.com',
  CRWD: 'crowdstrike.com',
  DDOG: 'datadoghq.com',
  NET: 'cloudflare.com',
  MDB: 'mongodb.com',
  SPLK: 'splunk.com',
  ESTC: 'elastic.co',
  PATH: 'uipath.com',
  CFLT: 'confluent.io',
  DBX: 'dropbox.com',
  TWLO: 'twilio.com',

  // Finance - Banks
  JPM: 'chase.com',
  BAC: 'bankofamerica.com',
  WFC: 'wellsfargo.com',
  GS: 'goldmansachs.com',
  MS: 'morganstanley.com',
  C: 'citigroup.com',
  USB: 'usbank.com',
  PNC: 'pnc.com',
  TFC: 'truist.com',
  COF: 'capitalone.com',

  // Finance - Payments & Fintech
  V: 'visa.com',
  MA: 'mastercard.com',
  AXP: 'americanexpress.com',
  BLK: 'blackrock.com',
  SCHW: 'schwab.com',
  COIN: 'coinbase.com',
  HOOD: 'robinhood.com',
  SOFI: 'sofi.com',
  AFRM: 'affirm.com',

  // Insurance
  'BRK-A': 'berkshirehathaway.com',
  'BRK-B': 'berkshirehathaway.com',
  BRK: 'berkshirehathaway.com',
  PGR: 'progressive.com',
  ALL: 'allstate.com',
  MET: 'metlife.com',
  TRV: 'travelers.com',

  // Healthcare / Pharma
  JNJ: 'jnj.com',
  PFE: 'pfizer.com',
  UNH: 'unitedhealthgroup.com',
  ABBV: 'abbvie.com',
  MRK: 'merck.com',
  LLY: 'lilly.com',
  NVO: 'novonordisk.com',
  TMO: 'thermofisher.com',
  ABT: 'abbott.com',
  BMY: 'bms.com',
  AMGN: 'amgen.com',
  GILD: 'gilead.com',
  MRNA: 'modernatx.com',
  REGN: 'regeneron.com',
  VRTX: 'vrtx.com',
  BIIB: 'biogen.com',
  ISRG: 'intuitive.com',
  DXCM: 'dexcom.com',
  ILMN: 'illumina.com',
  ZTS: 'zoetis.com',
  IDXX: 'idexx.com',
  DHR: 'danaher.com',
  SYK: 'stryker.com',
  BDX: 'bd.com',
  MDT: 'medtronic.com',
  ELV: 'elevancehealth.com',
  CI: 'cigna.com',
  HUM: 'humana.com',
  CVS: 'cvs.com',

  // Consumer - Retail
  WMT: 'walmart.com',
  COST: 'costco.com',
  HD: 'homedepot.com',
  LOW: 'lowes.com',
  TGT: 'target.com',
  EBAY: 'ebay.com',
  ETSY: 'etsy.com',
  W: 'wayfair.com',
  CHWY: 'chewy.com',
  BBY: 'bestbuy.com',
  DG: 'dollargeneral.com',
  DLTR: 'dollartree.com',
  ROST: 'rossstores.com',
  TJX: 'tjx.com',

  // Consumer - Apparel & Luxury
  NKE: 'nike.com',
  LULU: 'lululemon.com',
  GPS: 'gap.com',
  VFC: 'vfc.com',
  RL: 'ralphlauren.com',
  PVH: 'pvh.com',
  TPR: 'tapestry.com',

  // Consumer - Food & Beverage
  KO: 'coca-colacompany.com',
  PEP: 'pepsico.com',
  SBUX: 'starbucks.com',
  MCD: 'mcdonalds.com',
  CMG: 'chipotle.com',
  YUM: 'yum.com',
  DPZ: 'dominos.com',
  DNUT: 'krispykreme.com',
  QSR: 'rbi.com',
  MNST: 'monsterbevcorp.com',
  KDP: 'keurigdrpepper.com',
  STZ: 'cbrands.com',
  TAP: 'molsoncoors.com',
  BUD: 'ab-inbev.com',

  // Consumer - CPG
  PG: 'pg.com',
  CL: 'colgatepalmolive.com',
  KMB: 'kimberly-clark.com',
  CLX: 'thecloroxcompany.com',
  EL: 'elcompanies.com',
  ULTA: 'ulta.com',

  // Entertainment & Media
  DIS: 'disney.com',
  CMCSA: 'comcast.com',
  WBD: 'wbd.com',
  PARA: 'paramount.com',
  FOX: 'foxcorporation.com',
  LYV: 'livenationentertainment.com',

  // Gaming
  GME: 'gamestop.com',
  ATVI: 'activisionblizzard.com',

  // Industrial / Aerospace
  BA: 'boeing.com',
  LMT: 'lockheedmartin.com',
  RTX: 'rtx.com',
  NOC: 'northropgrumman.com',
  GD: 'gd.com',
  TXT: 'textron.com',
  HII: 'huntingtoningalls.com',

  // Industrial / Manufacturing
  CAT: 'caterpillar.com',
  DE: 'deere.com',
  GE: 'ge.com',
  HON: 'honeywell.com',
  MMM: '3m.com',
  EMR: 'emerson.com',
  ETN: 'eaton.com',
  ROK: 'rockwellautomation.com',
  IR: 'irco.com',
  PH: 'parker.com',
  ITW: 'itw.com',

  // Logistics
  UPS: 'ups.com',
  FDX: 'fedex.com',

  // Energy - Oil & Gas
  XOM: 'exxonmobil.com',
  CVX: 'chevron.com',
  COP: 'conocophillips.com',
  EOG: 'eogresources.com',
  SLB: 'slb.com',
  OXY: 'oxy.com',
  PSX: 'phillips66.com',
  MPC: 'marathonpetroleum.com',
  VLO: 'valero.com',
  HES: 'hess.com',
  DVN: 'devonenergy.com',
  FANG: 'diamondbackenergy.com',
  PXD: 'pxd.com',

  // Energy - Renewables & Utilities
  NEE: 'nexteraenergy.com',
  DUK: 'duke-energy.com',
  SO: 'southerncompany.com',
  D: 'dominionenergy.com',
  AEP: 'aep.com',
  EXC: 'exeloncorp.com',
  SRE: 'sempra.com',
  XEL: 'xcelenergy.com',
  ED: 'coned.com',
  ENPH: 'enphase.com',
  SEDG: 'solaredge.com',
  FSLR: 'firstsolar.com',

  // EV & Auto
  RIVN: 'rivian.com',
  LCID: 'lucidmotors.com',
  F: 'ford.com',
  GM: 'gm.com',
  TM: 'toyota.com',
  HMC: 'honda.com',
  STLA: 'stellantis.com',
  LI: 'lixiang.com',
  NIO: 'nio.com',
  XPEV: 'xiaopeng.com',

  // Telecom
  T: 'att.com',
  VZ: 'verizon.com',
  TMUS: 't-mobile.com',

  // Real Estate
  AMT: 'americantower.com',
  PLD: 'prologis.com',
  CCI: 'crowncastle.com',
  EQIX: 'equinix.com',
  DLR: 'digitalrealty.com',
  SPG: 'simon.com',
  O: 'realtyincome.com',
  WELL: 'welltower.com',
  AVB: 'avalonbay.com',
  EQR: 'equityapartments.com',

  // Materials
  LIN: 'linde.com',
  APD: 'airproducts.com',
  SHW: 'sherwin-williams.com',
  ECL: 'ecolab.com',
  DD: 'dupont.com',
  DOW: 'dow.com',
  NEM: 'newmont.com',
  FCX: 'fcx.com',
  NUE: 'nucor.com',
  ALB: 'albemarle.com',
};

/**
 * Get the primary logo URL from Unavatar CDN (fast, free, no auth)
 * Unavatar aggregates multiple sources including Clearbit, DuckDuckGo, Google, etc.
 */
export function getStockLogoUrl(ticker: string): string {
  const upperTicker = ticker.toUpperCase();
  const domain = TICKER_TO_DOMAIN[upperTicker];

  if (domain) {
    // Use Unavatar - free, fast, aggregates multiple logo sources
    return `https://unavatar.io/${domain}?fallback=false`;
  }

  // Fallback to local SVG for unknown tickers
  return `/logos/${upperTicker}.svg`;
}

/**
 * Get fallback logo URL (local SVG)
 */
export function getFallbackLogoUrl(ticker: string): string {
  return `/logos/${ticker.toUpperCase()}.svg`;
}

/**
 * Get initials from company name for fallback display
 */
export function getCompanyInitials(name: string): string {
  if (!name) return '?';

  const words = name.split(' ').filter(w => w.length > 0);
  if (words.length === 1) {
    return words[0].substring(0, 2).toUpperCase();
  }

  // Get first letter of first two significant words
  const significant = words.filter(w =>
    !['Inc', 'Inc.', 'Corp', 'Corp.', 'Ltd', 'Ltd.', 'LLC', 'Co', 'Co.', 'The', '&'].includes(w)
  );

  if (significant.length >= 2) {
    return (significant[0][0] + significant[1][0]).toUpperCase();
  }

  return words[0].substring(0, 2).toUpperCase();
}

/**
 * Check if we have a known logo for this ticker
 */
export function hasKnownLogo(ticker: string): boolean {
  return ticker.toUpperCase() in TICKER_TO_DOMAIN;
}
